module.exports = __webpack_public_path__ + "static/media/haimian-ruigaojinmaofu.85fab7ad.png";